export { default } from "./StripePaymentMethodForm";
